var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6 offset-md-6 content" }, [
        _c("div", { staticClass: "login-form-sec" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "login-content" }, [
            _c("form", [
              _c("h3", { staticClass: "form-title" }, [
                _vm._v("Update password")
              ]),
              _vm._v(" "),
              _vm.display.message
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-success",
                      attrs: { role: "alert" }
                    },
                    [_vm._v(_vm._s(_vm.display.message))]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.display.message
                ? _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.has("password") }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label visible-ie8 visible-ie9"
                        },
                        [_vm._v("Password")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-icon" }, [
                        (_vm.showPassword ? "text" : "password") === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.password,
                                  expression: "form.password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|password_format",
                                  expression: "'required|password_format'"
                                }
                              ],
                              ref: "password",
                              staticClass: "form-control",
                              attrs: {
                                name: "password",
                                placeholder: "Password",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.password)
                                  ? _vm._i(_vm.form.password, null) > -1
                                  : _vm.form.password
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.form.password,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form,
                                          "password",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form,
                                          "password",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.form, "password", $$c)
                                  }
                                }
                              }
                            })
                          : (_vm.showPassword ? "text" : "password") === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.password,
                                  expression: "form.password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|password_format",
                                  expression: "'required|password_format'"
                                }
                              ],
                              ref: "password",
                              staticClass: "form-control",
                              attrs: {
                                name: "password",
                                placeholder: "Password",
                                type: "radio"
                              },
                              domProps: {
                                checked: _vm._q(_vm.form.password, null)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(_vm.form, "password", null)
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.password,
                                  expression: "form.password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|password_format",
                                  expression: "'required|password_format'"
                                }
                              ],
                              ref: "password",
                              staticClass: "form-control",
                              attrs: {
                                name: "password",
                                placeholder: "Password",
                                type: _vm.showPassword ? "text" : "password"
                              },
                              domProps: { value: _vm.form.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "password",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                        _vm._v(" "),
                        !_vm.showPassword
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/eye.svg",
                                alt: "Show Password"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = !_vm.showPassword
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showPassword && _vm.form.password
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/eye-off.svg",
                                alt: "Hide Password"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = !_vm.showPassword
                                }
                              }
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.display.message
                ? _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.has("re_password") }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label visible-ie8 visible-ie9"
                        },
                        [_vm._v("Confirm Password")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-icon" }, [
                        (_vm.showConfirmPassword ? "text" : "password") ===
                        "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.re_password,
                                  expression: "form.re_password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|confirmed:password",
                                  expression: "'required|confirmed:password'"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                name: "re_password",
                                placeholder: "Confirm Password",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.re_password)
                                  ? _vm._i(_vm.form.re_password, null) > -1
                                  : _vm.form.re_password
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.form.re_password,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form,
                                          "re_password",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form,
                                          "re_password",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.form, "re_password", $$c)
                                  }
                                }
                              }
                            })
                          : (_vm.showConfirmPassword ? "text" : "password") ===
                            "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.re_password,
                                  expression: "form.re_password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|confirmed:password",
                                  expression: "'required|confirmed:password'"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                name: "re_password",
                                placeholder: "Confirm Password",
                                type: "radio"
                              },
                              domProps: {
                                checked: _vm._q(_vm.form.re_password, null)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(_vm.form, "re_password", null)
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.re_password,
                                  expression: "form.re_password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|confirmed:password",
                                  expression: "'required|confirmed:password'"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                name: "re_password",
                                placeholder: "Confirm Password",
                                type: _vm.showConfirmPassword
                                  ? "text"
                                  : "password"
                              },
                              domProps: { value: _vm.form.re_password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "re_password",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                        _vm._v(" "),
                        !_vm.showConfirmPassword
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/eye.svg",
                                alt: "Show Password"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showConfirmPassword = !_vm.showConfirmPassword
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showConfirmPassword
                          ? _c("img", {
                              staticClass: "eye-icon",
                              attrs: {
                                src: "/static/images/eye-off.svg",
                                alt: "Hide Password"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showConfirmPassword = !_vm.showConfirmPassword
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", display: "none" },
                            attrs: { id: "passerror" }
                          },
                          [
                            _vm._v(
                              "The password must contain minimum 8 characters with 1 letter and 1 number"
                            )
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-actions" },
                [
                  !_vm.display.message
                    ? _c(
                        "button",
                        {
                          staticClass: "b-btn red-btn",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.errors.count() > 0 || _vm.waiting == true
                          },
                          on: {
                            click: function($event) {
                              return _vm.resetPassword()
                            }
                          }
                        },
                        [_vm._v("Submit\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.display.message
                    ? _c("router-link", { attrs: { to: { name: "login" } } }, [
                        _c(
                          "button",
                          {
                            staticClass: "b-btn red-btn",
                            attrs: { type: "button" }
                          },
                          [_vm._v("Login")]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copyright" }, [
            _vm._v("Buy1Give1 @" + _vm._s(_vm.intYear))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://www.b1g1.com" } }, [
        _c("link", {
          attrs: {
            rel: "stylesheet",
            media: "all",
            type: "text/css",
            href: "/static/front/font_css.css"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo-default",
          attrs: { src: "/static/logos/logo.png", alt: "alt" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f231e0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f231e0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = null
// module chunks = 